import { useState, useMemo, useCallback } from 'react'
import { writeRsCmdSettings, getDmImei } from '../../../../redux/actions';
import { useDispatch, useSelector } from 'react-redux';
import '../RsConfig.css'
import Button from "../../../UI/Button/Button";
import Modal from '../../../UI/Modal/Modal'

export default function RsGNSS() {
    // Получаем текущее значение параметра из Redux
    const parameter = useSelector((state) => state.dmimei.data[0]);
    const role = useSelector((state) => state.userdata?.role);
    const dispatch = useDispatch();

        // Централизованное состояние модального окна
        const [modalState, setModalState] = useState({
            isOpen: false,
            paramName: '',
            inputValue: '',
            hasError: false,
            currentIndex: null
        });

    // Мемоизированные параметры
    const gnssParam = useMemo(() => [
        parameter?.PositionCShr || '...',
        parameter?.PositionCDl || '...',
    ], [parameter?.PositionCShr, parameter?.PositionCDl]);

    const nameParam = useMemo(() => [
        "Координата насосной, широта",
        "Координата насосной, долгота",
    ], []);

        // Обработчики модального окна
        const handleModalOpen = useCallback((name, index) => {
            setModalState({
                isOpen: true,
                paramName: name,
                inputValue: gnssParam[index],
                hasError: false,
                currentIndex: index
            });
        }, [gnssParam]);
    
        const handleModalClose = useCallback(() => {
            setModalState(prev => ({ ...prev, isOpen: false }));
        }, []);
    
        const handleInputChange = useCallback((e) => {
            setModalState(prev => ({ ...prev, inputValue: e.target.value }));
        }, []);

            // Оптимизированная функция сохранения
    const handleSave = useCallback(async () => {
        const { currentIndex, inputValue } = modalState;
        
        if (!inputValue || inputValue==="..." || inputValue===' ') {
            setModalState(prev => ({ ...prev, hasError: true }));
            return;
        }

        try {
            let processedValue = inputValue*1;

            if (currentIndex === 0 || currentIndex === 1) {
                // Обработка координат
                const coordinata = inputValue.replace(',', '.');
                processedValue = isNaN(coordinata) || coordinata.trim() === '' 
                    ? gnssParam[currentIndex] 
                    : coordinata.toString();
            }

            await dispatch(writeRsCmdSettings(parameter?.imei, processedValue, 30 + currentIndex));
            await dispatch(getDmImei(parameter?.imei));
            
            handleModalClose();
        } catch (error) {
            console.error("Ошибка при сохранении или обновлении данных: ", error);
        }
    }, [modalState, parameter?.imei, gnssParam, dispatch, handleModalClose]);

        // Оптимизированный рендеринг параметров
        const GNSSparametr = useMemo(() => (
            nameParam.map((text, index) => (
                <div className='ParamInput' key={index}> 
                    <label>{text}</label> 
                    <Button onClick={() => handleModalOpen(text, index)}>
                        <span className='buttonInput'>{gnssParam[index]}</span>
                    </Button> 
                </div>
            ))
        ), [nameParam, gnssParam, handleModalOpen]);

    return (
        <div className='cardDm'>
            <h3>GNSS</h3>
            <div className='DmGnssConfig'>
                {GNSSparametr} 
            </div>   
            
            {/* Единое модальное окно */}
            <Modal open={modalState.isOpen}>
                <div className='modalHeader'>
                    <h3>Введите новое значение</h3>
                    <svg onClick={handleModalClose} height="30" viewBox="0 0 200 200" width="30">    
                        <path d="M114,100l49-49a9.9,9.9,0,0,0-14-14L100,86,51,37A9.9,9.9,0,0,0,37,51l49,49L37,149a9.9,9.9,0,0,0,14,14l49-49,49,49a9.9,9.9,0,0,0,14-14Z" />
                    </svg> 
                </div>
                <div className='modalInfo'> 
                    <label className='labelInfo'>{modalState.paramName}</label>
                    <h4 className='labelInfoQuet'>
                        {modalState.hasError ? "Передумали?" : `Желаете установить ${modalState.inputValue}?`}
                    </h4>
                </div>
                <div className='contentControl'>
                    <input 
                        type='number' 
                        className='input' 
                        value={modalState.inputValue} 
                        onChange={handleInputChange}
                        style={{ border: modalState.hasError ? '1px solid red' : null }} 
                    />
                    <div className='modalButton'>
                        <Button onClick={handleModalClose} color="#d2e9d2">Отмена</Button>
                        <Button onClick={handleSave} color="#4bdd4b">Сохранить</Button>
                    </div>
                </div>
            </Modal>
        </div>
    )
}